import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import Green from "../images/green.png";

const sections = [
  {
    title: "Introduction",
    content:
      "GreenFarm AI is an innovative agricultural technology solution currently under development by Innova Fondation. It is designed to support farmers in the Democratic Republic of Congo (DRC) and the East African region by using data analytics to address climate change challenges in agriculture. The platform monitors soil nutrients, delivers localized weather forecasts, and offers sustainable farming recommendations, helping farmers make smarter, data-driven decisions.",
  },
  {
    title: "Problem",
    content:
      "Farmers in the DRC and across East Africa face major challenges such as unpredictable weather, declining soil quality, and limited access to reliable agricultural information. These factors contribute to reduced crop yields and pose a risk to regional food security. Without accurate data, farmers struggle to optimize their practices and protect their livelihoods.",
  },
  {
    title: "Solution",
    content:
      "GreenFarm AI addresses these challenges through a smart, user-friendly application. It combines real-time soil nutrient analysis, hyper-local weather forecasting, and personalized advice for sustainable practices. This integrated approach enables farmers in the DRC and East Africa to reduce waste, conserve resources, and increase resilience to climate stressors.",
  },
  {
    title: "Market",
    content:
      "Agriculture is central to the economies of the DRC and much of East Africa, with large portions of the population relying on it for income and sustenance. Despite this importance, the sector remains under-digitized. GreenFarm AI takes advantage of growing mobile phone usage in rural areas, offering a scalable opportunity to introduce precision agriculture tools throughout the region.",
  },
  {
    title: "Business Model",
    content:
      "The platform will use a subscription-based model, allowing farmers to access premium features at an affordable cost. To ensure inclusivity, partnerships with local NGOs and government agencies across the DRC and East Africa will help subsidize subscriptions for smallholder farmers, expanding reach and impact.",
  },
  {
    title: "Marketing and Adoption Strategy",
    content:
      "Adoption efforts will focus on collaborating with local cooperatives, community organizations, and agricultural extension services. On-ground training, demos, and workshops will promote awareness and usability. To broaden outreach, GreenFarm AI will also use social media and local radio campaigns in both the DRC and East African regions.",
  },
  {
    title: "Conclusion",
    content:
      "GreenFarm AI represents a transformative approach to sustainable agriculture in the DRC and East Africa. By combining advanced data analytics with accessibility and practical tools for farmers, it aims to improve productivity, adapt to climate variability, and contribute to long-term food security across the region.",
  },
];

const DemoProduct = () => {
  return (
    <div className="max-w-7xl mx-auto py-10">
      <div className="max-w-7xl mx-auto py-10">
        <NavBar />
        <div className="max-w-4xl mx-auto p-6 space-y-8 bg-white shadow-lg rounded-2xl">
          <img src={Green} alt="Green Farm" className="w-2/3 h-auto" />
          {sections.map((section, index) => (
            <section key={index}>
              <h2 className="text-3xl font-semibold mb-4">{section.title}</h2>{" "}
              {/* Adjusted text size here */}
              <p className="text-lg text-gray-700">{section.content}</p>{" "}
              {/* Adjusted text size here */}
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DemoProduct;
